// The exact Liquid the pricing-table block serializes to. The server's Liquid
// file system (config/initializers/liquid.rb) resolves "pricing_table" to
// app/views/documents/liquid_snippets/_pricing_table.liquid.
//
// This module is intentionally dependency-free (no Tiptap, no DOM) so it can be
// unit-tested under `node --test` and imported by the Tiptap node extension.
export const PRICING_TABLE_INCLUDE = '{% include "pricing_table" %}';

// True when a block of text is exactly the pricing-table include tag (ignoring
// surrounding whitespace). Used to reconstitute bare-text includes — e.g.
// AI-generated or hand-typed — back into the atom node on load.
export function isPricingTableText(text) {
  return typeof text === "string" && text.trim() === PRICING_TABLE_INCLUDE;
}
